import { Text } from '../../primitives/Text';
import { View } from '../../primitives/View';
import { cn } from '../../utils/cn';
import type { AccountSeedNoticeProps } from './AccountSeedNotice.types';

/**
 * "Bringing your account over" — what a legacy account sees on its first
 * sign-in while its Durable Object seeds itself from the legacy export. ONE
 * surface on both clients, driven by the shared seed state
 * (`sync-client/account-seed.ts`); each platform injects only the shell that
 * places it over the app and the art it can run.
 *
 * Two moments, two messages: working on it, and waiting (trying again by
 * itself). There is no failure screen: every legacy account seeds, and while
 * anything is wrong on our side the app keeps waiting and asking.
 *
 * Labels arrive pre-translated (the DS carries no i18n).
 */
export function AccountSeedNotice({
  title,
  description,
  artwork,
  children,
  className,
  testID,
}: AccountSeedNoticeProps) {
  return (
    <View
      className={cn(
        'w-full flex-1 flex-col items-center justify-center gap-6 bg-background px-6 py-8',
        className,
      )}
      testID={testID}>
      {artwork}
      {/* `text-center` sits on each Text: native has no text inheritance
          through a View (see SurfaceEmptyState). */}
      <View className="max-w-sm flex-col items-center gap-2">
        <Text className="text-center text-h4 font-semibold text-subtitle-800 native:font-mona-semibold">
          {title}
        </Text>
        <Text className="text-center text-b2 font-medium text-body-600 native:font-mona-medium">
          {description}
        </Text>
      </View>
      {children}
    </View>
  );
}
(AccountSeedNotice as { displayName?: string }).displayName = 'AccountSeedNotice';
